import animationText from './timelines/animations/text';
import initialText from './timelines/initial/text';
import animationTitle from './timelines/animations/title';
import initialTitle from './timelines/initial/title';
import animationFade from './timelines/animations/fade';
import initialFade from './timelines/initial/fade';
import animationStaggerFade from './timelines/animations/stagger-fade';
import initialStaggerFade from './timelines/initial/stagger-fade';
import animationLine from './timelines/animations/line';
import initialLine from './timelines/initial/line';
import animationTitleNext from './timelines/animations/title-next';
import initialTitleNext from './timelines/initial/title-next';

import { menuOpen, menuClose, menuIn, menuOut, menuLang, menuInfo, menuHome } from './timelines/transitions/menu';
import { defaultIn, defaultOut } from './timelines/transitions/default';
import { parentChildIn, parentChildOut } from './timelines/transitions/parent-child';
import { siblingsIn, siblingsOut } from './timelines/transitions/siblings';
import { siblingsPrevIn, siblingsPrevOut } from './timelines/transitions/siblings-prev';

import hoverBreadcrumb from './timelines/hovers/breadcrumb';
import hoverPointerImage from './timelines/hovers/pointer-image';
import hoverProject from './timelines/hovers/project';
import hoverLink from './timelines/hovers/link';
import hoverLogo from './timelines/hovers/logo';

export const animations = new Map();

animations.set('text', animationText);
animations.set('title', animationTitle);
animations.set('title-next', animationTitleNext);
animations.set('fade', animationFade);
animations.set('stagger-fade', animationStaggerFade);
animations.set('line', animationLine);

export const initial = new Map();

initial.set('text', initialText);
initial.set('title', initialTitle);
initial.set('title-next', initialTitleNext);
initial.set('fade', initialFade);
initial.set('stagger-fade', initialStaggerFade);
initial.set('line', initialLine);

export const transition = new Map();

transition.set('menu-open', menuOpen);
transition.set('menu-close', menuClose);
transition.set('menu-in', menuIn);
transition.set('menu-out', menuOut);
transition.set('menu-lang', menuLang);
transition.set('menu-info', menuInfo);
transition.set('menu-home', menuHome);

transition.set('default-in', defaultIn);
transition.set('default-out', defaultOut);
transition.set('parent-child-in', parentChildIn);
transition.set('parent-child-out', parentChildOut);
transition.set('siblings-in', siblingsIn);
transition.set('siblings-out', siblingsOut);
transition.set('siblings-prev-in', siblingsPrevIn);
transition.set('siblings-prev-out', siblingsPrevOut);

export const hovers = new Map();
hovers.set('breadcrumb', hoverBreadcrumb);
hovers.set('pointer-image', hoverPointerImage);
hovers.set('project', hoverProject);
hovers.set('link', hoverLink);
hovers.set('logo', hoverLogo);